import { Image } from 'components/Image/Image';
import { useId } from 'react';
import { FeefoLogo } from './FeefoLogo';

const STAR_PATH =
  'M8.5 0.75l2.27 4.6 5.08.74-3.68 3.58.87 5.06-4.54-2.39-4.55 2.39.87-5.06L1.15 6.09l5.08-.74L8.5.75z';

type StarProps = {
  fill: number;
  index: number;
  compact: boolean;
  instanceId: string;
};

const RatingStar = ({ fill, index, compact, instanceId }: StarProps) => {
  const clipId = `feefo-star-fill-${instanceId}-${index}`;

  return (
    <svg
      aria-hidden="true"
      className={compact ? 'h-3 w-3' : 'h-4 w-4'}
      data-fill={fill}
      data-testid="feefo-star"
      viewBox="0 0 17 17"
    >
      <defs>
        <clipPath data-testid="feefo-star-clip" id={clipId}>
          <rect
            data-testid="feefo-star-clip-rect"
            width={`${fill}%`}
            height="17"
          />
        </clipPath>
      </defs>
      <path d={STAR_PATH} fill="#DADBDC" />
      <path
        d={STAR_PATH}
        data-testid="feefo-star-fill"
        fill="#FFC61B"
        clipPath={`url(#${clipId})`}
      />
    </svg>
  );
};

type Props = {
  compact?: boolean;
};

const TrustMarks = ({ compact = false }: Props) => {
  const instanceId = useId().replace(/:/g, '');

  return (
    <div
      aria-label="Feefo rating: 4.6 out of 5. ATIA Accredited."
      className={`flex items-center justify-center ${
        compact ? 'gap-3' : 'gap-5'
      }`}
      data-testid="dealsaway-trust-marks"
      role="group"
    >
      <FeefoLogo compact={compact} />

      <div aria-hidden="true" className="flex shrink-0 items-center gap-0.5">
        {[100, 100, 100, 100, 60].map((fill, index) => (
          <RatingStar
            compact={compact}
            fill={fill}
            index={index}
            instanceId={instanceId}
            key={index}
          />
        ))}
      </div>

      <div
        aria-hidden="true"
        className={compact ? 'h-[25px] w-20' : 'h-8 w-[102px]'}
      >
        <Image
          alt=""
          className="!h-full !w-full !object-contain"
          cloud="dealsaway"
          path="dealsaway/static/home/atia"
        />
      </div>
    </div>
  );
};

export { TrustMarks };
